import { useEffect, useState , useRef} from "react";
import Table from 'react-bootstrap/Table';
import Icon from "../Icon/Icon";
import { Navigate } from "react-router-dom";
import { Spinner } from "react-bootstrap";
import { Alert, Button } from "react-bootstrap";
import html2canvas from "html2canvas";
import { jsPDF } from "jspdf";
import { useApiClient } from "../../ApiService/useApiClient";



function getMonthName(monthNumber) {
    const date = new Date();
    date.setMonth(monthNumber - 1);
    
  
    return date.toLocaleString('en-GB', {
      month: 'long',
    });
  }

const CurrYear = new Date().getFullYear();  
const CurrMonth = new Date().getMonth() + 1; 

const Emar = ({CustomerID}) => {

    const api = useApiClient();

    const dataFetchedRef = useRef(false);
    const [data, setData] = useState(null);
    const [error, setError] = useState(null);
    const [monthNo, setMonthNo] = useState(CurrMonth);
    const [yearNo, setYearNo] = useState(CurrYear);
    const [isLoading, setisLoading] = useState(false);
    const [isExporting, setIsExporting] = useState(false);

    // Ref for the content to export
    const pdfRef = useRef(null);


    const ApiGetData = async (URL,setdataFunc, setErrorFunc, setIsLoadingFunc) => {
      const CompleteURL = URL;        
      setIsLoadingFunc(true)    
      try{          
          const response = await api.get(CompleteURL);
          setdataFunc(response.data);
          setIsLoadingFunc(false)            
      } catch(error) {
          setErrorFunc(error);   
          setIsLoadingFunc(false)       
      }
    };

    useEffect(()=>{

        if (dataFetchedRef.current) return;
        dataFetchedRef.current = true;
        ApiGetData('HMCareTask/getemardata/'+CustomerID+'/'+monthNo+'/'+yearNo ,setData, setError, setisLoading)
        
    },[monthNo])

    // PDF export handler
    const handleExportPdf = async () => {
      setIsExporting(true);
      const input = pdfRef.current;
      if (!input) return;
      const canvas = await html2canvas(input, { scale: 2 });
      const imgData = canvas.toDataURL('image/png');
      const pdf = new jsPDF({
          orientation: 'landscape',
          unit: 'px',
          format: 'a4',
      });
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = pdf.internal.pageSize.getHeight();
      pdf.addImage(imgData, 'PNG', 0, 0, pdfWidth, pdfHeight);
      pdf.save(`eMAR_${CustomerID}_${monthNo}_${yearNo}.pdf`);
      setIsExporting(false);
  };

    if (error) 
    {      
      if(error.message.indexOf("status code 401")){
        return <Navigate to="/auths/auth-login" />
      } 
    }

    if(!data) (
        <Spinner animation="border" variant="primary" />
    );
    if(isLoading) (
        <Spinner animation="border" variant="primary" />
    );


  {error && <Alert variant="danger">{error}</Alert>}


    function PreClick(){
        dataFetchedRef.current = false;
        if(monthNo > 1) setMonthNo(monthNo-1);     
        else {
            setYearNo(yearNo-1)       
            setMonthNo(12);
            
        }
    }
    
    function NextClick(){
        dataFetchedRef.current = false;
        if(monthNo < 12) setMonthNo(monthNo+1); 
        else {
            setYearNo(yearNo+1)
            setMonthNo(1);            
        }
    }


  return (

    <>    
    <span>
        {/* {monthNo} -- {CurrMonth} */}  
        <Button variant="outline-primary" size="sm" onClick={PreClick}><Icon name="chevron-left"></Icon></Button> 
        <span style={{marginLeft:"5px", marginRight:"5px", fontSize:"16px", fontWeight:"bold",}}>{getMonthName(monthNo)} {yearNo} </span>
        <Button variant="outline-primary" size="sm" onClick={NextClick}><Icon name="chevron-right"></Icon></Button>   
        <Button
                variant="success"
                size="sm"
                style={{ marginLeft: "15px" }}
                onClick={handleExportPdf}
            >
                Export as PDF
            </Button>      
    </span>
    <br></br>
    <br></br>
    <div ref={pdfRef}>

    {isExporting && (
    <div>
      <h1>PDF Only Title</h1>
      <p>This paragraph is only included in the PDF output.</p>
    </div>
  )}
    <Table striped bordered hover size="sm">    
      <thead>       
        <tr>          
            <td>&nbsp;</td>      
            {data && data.emarDateHeadings.map((ihead)=>                          
           <td align={"center"} style={{fontSize:"15px"}}><b>{ihead}</b></td> 
            )}             
        </tr>
      </thead>
      <tbody>
        {data && data.emarMedItems.map((meditem)=>
            <>
                <tr>         
                    <td colSpan={data.emarDateHeadings.length+1}><span><b>{meditem.emarMedication.emarMedicationName}</b></span></td>
                </tr>                

                    {meditem.emarItems.map((schItem)=>
                    <>
                    <tr>
                        <td align="right">{schItem.sch}</td> 
                        {schItem.emarItemDataList.map((iItem)=>    
                            <td align="center">
                                {iItem=="y" && <Icon name="circle-fill" variant="success" size="sm"></Icon>}
                                {iItem=="n" && <Icon name="circle-fill" variant="danger" size="sm"></Icon>}
                                {iItem !="y" && iItem != "n" && <>{iItem}</>}
                                </td>
                        )}    
                    </tr>      
                    </>
                    )}  
               
            </>
        )}
      </tbody>
    </Table>  
    </div> 
    </>
  )
}

export default Emar